export const feedRegExp = /feed/i;
export const profileRegExp = /profile/i;